var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"explanation-modal",attrs:{"cancel-variant":"outline-secondary","centered":"","size":"xl","hide-footer":""}},[_c('Explanation',{attrs:{"explanation":_vm.explanation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }